import { HStack, Text } from '@chakra-ui/react';
import DomainIconTiles from '@/modules/content/common/DomainIconTiles';
import formatRelativeAge from '@/modules/content/common/formatRelativeAge';
import { TContent, TContentDomain } from '@/types/Content.types';

// Publication age on the left, with wellness-domain tiles on the right.
const PublishedMetaRow = ({ content, isOnDark = false }: { content: TContent; isOnDark?: boolean }) => {
  const age = formatRelativeAge(content.publishedAt ?? content.createdAt);

  return (
    <HStack width="100%" justify="space-between" align="center" gap="10px">
      <Text
        fontFamily="Urbanist"
        fontSize="12px"
        fontWeight={800}
        color={isOnDark ? 'rgba(255, 255, 255, 0.8)' : 'text.mediumGray'}
        textAlign="left"
        flex={1}
      >
        {age}
      </Text>
      {content.domains?.length > 0 && (
        <DomainIconTiles domains={content.domains as TContentDomain[]} max={3} />
      )}
    </HStack>
  );
};

export default PublishedMetaRow;
